import { useCallback, useState } from 'react';
import { useBoolState } from '@/hooks/state/useBoolState';
export const useTopImageZoomSlider = () => {
    /** モーダル内で最初に表示する項目 index */
    const [modalInitialSlide, changeModalInitialSlide] = useState(0);
    // モーダル表示
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState();
    /**
     * 画像クリック時の処理
     */
    const onClickSliderItem = useCallback((event) => {
        const index = parseInt(event.currentTarget.value, 10);
        // モーダル内で最初に表示する項目を設定
        changeModalInitialSlide(index);
        showModal();
    }, [changeModalInitialSlide, showModal]);
    return {
        hideModal,
        isShowModal,
        modalInitialSlide,
        onClickSliderItem,
    };
};
